class MainHeader extends HTMLElement {
  constructor() {
    super();
    this.currentScrollTop = 0;

    this.enlargedLogo = this.querySelector(".enlarged-logo");
    if (this.classList.contains("hide-on-scroll")) {
      window.addEventListener("scroll", this.onScroll.bind(this), false);
    }

    if (this.enlargedLogo) {
      setTimeout(
        function () {
          this.classList.add("enlarged-logo-loaded");
        }.bind(this),
        500,
      );
    }
    const resizeObserver = new ResizeObserver(
      this.updateHeaderHeight.bind(this),
    );
    resizeObserver.observe(this);
    window.addEventListener("scroll", this.headerFillToggle.bind(this), false);
    window.addEventListener(
      "scroll",
      this.calculateAnnouncementHeight.bind(this),
      false,
    );
    this.addEventListener("mouseover", this.headerFillAdd.bind(this), false);
    this.addEventListener("mouseout", this.headerFillRemove.bind(this), false);
    this.handleMenuEvents();
  }

  onScroll() {
    if (document.body.classList.contains("account-menu-open")) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.headerHeight = this?.getBoundingClientRect().height.toFixed(2) || 0;
    // Keep the shared Amaro header in place on every page and viewport.
    if (document.body.classList.contains("amaro-shell")) {
      this.classList.remove("sticky-header-hide");
      document.body.style.setProperty("--header-height", `${this.headerHeight}px`);
      this.currentScrollTop = Math.max(0, scrollTop);
      return;
    }
    if (scrollTop > 100) {
      if (scrollTop > this.currentScrollTop) {
        this.classList.add("sticky-header-hide");
        document.body.style.setProperty("--header-height", `0px`);
      } else {
        this.classList.remove("sticky-header-hide");
        document.body.style.setProperty(
          "--header-height",
          `${this.headerHeight}px`,
        );
      }
    } else {
      this.classList.remove("sticky-header-hide");
      document.body.style.setProperty(
        "--header-height",
        `${this.headerHeight}px`,
      );
    }

    this.currentScrollTop = scrollTop;
  }
  headerFillToggle() {
    if (document.body.classList.contains("account-menu-open")) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.enlargedLogo && scrollTop > 10) {
      this.classList.add("original-logo");
    } else {
      this.classList.remove("original-logo");
    }
    if (this.classList.contains("transparency-header")) {
      if (scrollTop > 110) {
        this.classList.add("header-fill");
      } else {
        this.classList.remove("header-fill");
      }
    }

    this.currentScrollTop = scrollTop;
  }
  headerFillAdd(event) {
    let logoStatus =
        this.enlargedLogo && !this.classList.contains("original-logo"),
      megaMenuStatus =
        event.target.hasAttribute("data-menu-with-child") == true ||
        event.target.closest("[data-menu-with-child]") != null;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (logoStatus && megaMenuStatus == false) return;
    if (
      scrollTop <= 110 &&
      this.classList.contains("transparency-header") &&
      !this.classList.contains("header-fill")
    ) {
      this.classList.add("header-fill");
    }
  }
  headerFillRemove() {
    if (document.body.classList.contains("account-menu-open")) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (
      scrollTop <= 110 &&
      this.classList.contains("transparency-header") &&
      this.classList.contains("header-fill")
    ) {
      this.classList.remove("header-fill");
    }
  }
  calculateAnnouncementHeight() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.setProperty(
      "--announcement-height",
      `${Math.max(this.announcementbarHeight - scrollTop, 0)}px`,
    );
  }

  updateHeaderHeight() {
    this.announcementbarHeight =
      document
        .querySelector(".announcementbar-wrapper")
        ?.getBoundingClientRect()
        .height.toFixed(2) || 0;
    this.headerHeight = this.getBoundingClientRect().height.toFixed(2) || 0;
    document.body.style.setProperty(
      "--announcement-height",
      `${this.announcementbarHeight}px`,
    );
    document.body.style.setProperty(
      "--header-height",
      `${this.headerHeight}px`,
    );
  }

  handleMenuEvents() {
    Array.from(this.querySelectorAll("[data-menu-with-child]")).forEach(
      function (menu) {
        menu.addEventListener("keydown", function (event) {
          if (event.key === "Escape") {
            if (
              menu.nextElementSibling &&
              getFocusableElements(menu.nextElementSibling).length > 0
            ) {
              getFocusableElements(menu.nextElementSibling)[0].focus();
            } else if (
              menu.closest(".site-header-nav").nextElementSibling &&
              getFocusableElements(
                menu.closest(".site-header-nav").nextElementSibling,
              ).length > 0
            ) {
              getFocusableElements(
                menu.closest(".site-header-nav").nextElementSibling,
              )[0].focus();
            }
          }
        });
      },
    );
  }
}

customElements.define("main-header", MainHeader);

class HeaderDrawerMenu extends HTMLElement {
  constructor() {
    super();
    this.headerSection = this.closest(".section-main-header");
    this.closeBtns = this.querySelectorAll("[data-close-drawer]");
    this.drawerBtn = this.headerSection?.querySelector(".header-menu-btn");
    Array.from(this.closeBtns).forEach(
      function (closeBtn) {
        closeBtn.addEventListener(
          "click",
          function (event) {
            event.preventDefault();
            this.closeDrawer();
          }.bind(this),
        );
      }.bind(this),
    );
    if (this.drawerBtn) {
      this.drawerBtn.addEventListener("click", this.toggleDrawer.bind(this));
    }
    this._subMenuEvents();
  }
  _subMenuEvents() {
    this.subMenusOpen = this.querySelectorAll("[data-submenu-open]");
    Array.from(this.subMenusOpen).forEach(function (subMenu) {
      subMenu.addEventListener(
        "click",
        function () {
          const mainWrapper = subMenu.closest("[data-menu-link]");
          const subMenuWrapper = mainWrapper?.querySelector(
            "[data-submenu-wrapper]",
          );
          if (subMenuWrapper) {
            subMenuWrapper.classList.add("open");
          }
        }.bind(this),
      );
    });
    this.subMenusClose = this.querySelectorAll("[data-submenu-close]");
    Array.from(this.subMenusClose).forEach(function (subMenu) {
      subMenu.addEventListener(
        "click",
        function () {
          const subMenuWrapper = subMenu.closest("[data-submenu-wrapper]");
          if (subMenuWrapper) {
            subMenuWrapper.classList.remove("open");
            const grandSubMenus = subMenuWrapper.querySelectorAll(
              "[data-submenu-link].active",
            );
            Array.from(grandSubMenus).forEach(function (menu) {
              menu.classList.remove("active");
              DOMAnimations.slideUp(
                menu.querySelector("[data-grand-submenu-wrapper]"),
              );
            });
          }
        }.bind(this),
      );
    });

    this.grandSubMenusToggle = this.querySelectorAll(
      "[data-grand-submenu-toggle]",
    );
    Array.from(this.grandSubMenusToggle).forEach(function (grandSubMenu) {
      grandSubMenu.addEventListener(
        "click",
        function () {
          const mainWrapper = grandSubMenu.closest("[data-submenu-link]");
          const grandSubMenuWrapper = mainWrapper?.querySelector(
            "[data-grand-submenu-wrapper]",
          );
          if (grandSubMenuWrapper) {
            if (mainWrapper.classList.contains("active")) {
              mainWrapper.classList.remove("active");
              DOMAnimations.slideUp(grandSubMenuWrapper);
            } else {
              mainWrapper.classList.add("active");
              DOMAnimations.slideDown(grandSubMenuWrapper);
            }
          }
        }.bind(this),
      );
    });
  }
  toggleDrawer() {
    if (this.drawerBtn.classList.contains("active")) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }
  closeDrawer() {
    document.body.classList.remove("overflow-hidden");
    this.classList.remove("open");
    this.drawerBtn.classList.remove("active");
    setTimeout(
      function () {
        this.subMenus = this.querySelectorAll("[data-submenu-wrapper].open");
        Array.from(this.subMenus).forEach(function (subMenu) {
          subMenuWrapper.classList.remove("open");
        });
        this.grandSubMenus = this.querySelectorAll(
          "[data-submenu-link].active",
        );
        Array.from(this.grandSubMenus).forEach(function (menu) {
          menu.classList.remove("active");
          DOMAnimations.slideUp(
            menu.querySelector("[data-grand-submenu-wrapper]"),
          );
        });
      }.bind(this),
      400,
    );
  }
  openDrawer() {
    document.body.classList.add("overflow-hidden");
    this.classList.add("open");
    this.drawerBtn.classList.add("active");
  }
}
customElements.define("header-drawer-menu", HeaderDrawerMenu);

/* Account sheet: open under icon for both top (transparent) and scrolled (filled) header */
var accountDialogPositionBound = false;

function getMainHeaderEl() {
  return document.querySelector("main-header.header-wrapper, .header-wrapper");
}

function getHeaderSectionEl(header) {
  return header ? header.closest(".section-main-header") : null;
}

function getScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || 0;
}

function syncAccountDialogPosition() {
  document
    .querySelectorAll(
      ".header-icons .account-menu:not(.account-menu--mobile) shopify-account",
    )
    .forEach(function (accountEl) {
      var anchor =
        accountEl.querySelector('[slot="signed-out-avatar"]') || accountEl;
      var rect = anchor.getBoundingClientRect();
      var header = getMainHeaderEl();
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      // Use whichever is lower: icon bottom or header bottom (handles announcement + both header states)
      var top =
        Math.max(Math.round(rect.bottom), Math.round(headerBottom), 0) + 12;
      accountEl.style.setProperty(
        "--shopify-account-dialog-position-top",
        top + "px",
      );
    });
}

function showHeaderForAccountMenu(header) {
  if (!header) return;

  header.classList.remove("sticky-header-hide");
  var height =
    parseFloat(header.headerHeight) ||
    header.getBoundingClientRect().height ||
    0;
  document.body.style.setProperty("--header-height", height.toFixed(2) + "px");
}

function shouldPinHeaderForAccountMenu(scrollTop) {
  return scrollTop > 10;
}

function pinHeaderForAccountMenu(header) {
  var section = getHeaderSectionEl(header);
  if (!section || !header) return;

  section.style.setProperty(
    "--account-menu-pin-height",
    header.getBoundingClientRect().height + "px",
  );
  document.body.classList.add("account-menu-header-fixed");
  document.body.classList.add("account-menu-section-spacer");
}

function unpinHeaderForAccountMenu(header) {
  var section = getHeaderSectionEl(header);
  if (section) {
    section.style.removeProperty("--account-menu-pin-height");
  }
  document.body.classList.remove("account-menu-header-fixed");
  document.body.classList.remove("account-menu-section-spacer");
}

function finishAccountMenuClose(header, section, scrollTop, skipFillSync) {
  if (!header) return;

  if (!skipFillSync && typeof header.headerFillToggle === "function") {
    header.headerFillToggle();
  }
  if (
    header.classList.contains("hide-on-scroll") &&
    typeof header.onScroll === "function"
  ) {
    header.onScroll();
  } else if (scrollTop <= 100) {
    showHeaderForAccountMenu(header);
  }

  requestAnimationFrame(function () {
    if (header) {
      header.classList.remove("account-menu-no-transition");
    }
    if (section) {
      section.classList.remove("account-menu-no-transition");
    }
  });
}

function onAccountMenuOpen() {
  var scrollTop = getScrollTop();
  var header = getMainHeaderEl();

  // Measure position first — before any class changes that could jump the page
  syncAccountDialogPosition();

  showHeaderForAccountMenu(header);

  document.body.classList.add("account-menu-open");

  if (shouldPinHeaderForAccountMenu(scrollTop)) {
    pinHeaderForAccountMenu(header);
    if (header && header.classList.contains("transparency-header")) {
      header.classList.add("header-fill");
    }
  } else {
    unpinHeaderForAccountMenu(header);
  }

  // Keep scroll where it was (prevent jump when sheet opens at top)
  if (scrollTop <= 10) {
    window.scrollTo(0, scrollTop);
  }

  requestAnimationFrame(function () {
    syncAccountDialogPosition();
    if (scrollTop <= 10 && getScrollTop() !== scrollTop) {
      window.scrollTo(0, scrollTop);
    }
  });
}

function onAccountMenuClose() {
  var header = getMainHeaderEl();
  var section = getHeaderSectionEl(header);
  var scrollTop = getScrollTop();
  var wasFixed = document.body.classList.contains("account-menu-header-fixed");
  var skipFillSync = scrollTop > 110;

  if (header) {
    header.classList.add("account-menu-no-transition");
    if (header.classList.contains("transparency-header")) {
      if (scrollTop > 110) {
        header.classList.add("header-fill");
      } else if (scrollTop > 10) {
        header.classList.remove("header-fill");
      } else {
        header.classList.remove("header-fill");
      }
    }
  }
  if (section) {
    section.classList.add("account-menu-no-transition");
  }

  document.body.classList.remove("account-menu-open");

  if (scrollTop > 110) {
    window.scrollTo(0, scrollTop);
    finishAccountMenuClose(header, section, scrollTop, true);

    var unpinDone = false;
    var deferredUnpin = function () {
      if (unpinDone) return;
      unpinDone = true;
      window.removeEventListener("scroll", deferredUnpin);
      clearTimeout(unpinTimer);
      document.body.classList.remove("account-menu-header-fixed");
      document.body.classList.remove("account-menu-section-spacer");
      if (section) {
        section.style.removeProperty("--account-menu-pin-height");
      }
    };
    var unpinTimer = setTimeout(deferredUnpin, 400);

    window.addEventListener("scroll", deferredUnpin, { passive: true });
    return;
  }

  if (!wasFixed) {
    window.scrollTo(0, scrollTop);
    finishAccountMenuClose(header, section, scrollTop, skipFillSync);
    return;
  }

  // Drop fixed first; keep section spacer one frame so header re-enters flow smoothly.
  document.body.classList.remove("account-menu-header-fixed");
  window.scrollTo(0, scrollTop);

  requestAnimationFrame(function () {
    document.body.classList.remove("account-menu-section-spacer");
    if (section) {
      section.style.removeProperty("--account-menu-pin-height");
    }
    window.scrollTo(0, scrollTop);
    finishAccountMenuClose(header, section, scrollTop, skipFillSync);
  });
}

function accountDialogPositionInit() {
  syncAccountDialogPosition();

  document.querySelectorAll("shopify-account").forEach(function (accountEl) {
    accountEl.removeEventListener("open", onAccountMenuOpen);
    accountEl.removeEventListener("close", onAccountMenuClose);
    accountEl.addEventListener("open", onAccountMenuOpen);
    accountEl.addEventListener("close", onAccountMenuClose);
  });

  if (!accountDialogPositionBound) {
    accountDialogPositionBound = true;
    window.addEventListener("resize", syncAccountDialogPosition);
    window.addEventListener("scroll", syncAccountDialogPosition, {
      passive: true,
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  accountDialogPositionInit();
  if (window.customElements && customElements.whenDefined) {
    customElements
      .whenDefined("shopify-account")
      .then(accountDialogPositionInit);
  }
});
document.addEventListener("shopify:section:load", accountDialogPositionInit);
